import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/components/ThemeProvider";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";
import Materials from "./pages/Materials";
import MaterialDetail from "./pages/MaterialDetail";
import Applications from "./pages/Applications";
import ApplicationDetail from "./pages/ApplicationDetail";
import AdminReview from "./pages/AdminReview";
import AdminPendingReview from "./pages/AdminPendingReview";
import AdminContent from "./pages/AdminContent";
import AdminMaterialEditor from "./pages/AdminMaterialEditor";
import About from "./pages/About";
import Auth from "./pages/Auth";
import OAuthConsent from "./pages/OAuthConsent";
import NotFound from "./pages/NotFound";
import ProtectedRoute from "./components/ProtectedRoute";
import { I18nProvider } from "./i18n/I18nProvider";

// Public pages exist once per language: English at the root, others prefixed
const PUBLIC_PREFIXES = ["", "/zh", "/it"];
const publicRoutes = PUBLIC_PREFIXES.flatMap((prefix) => [
  <Route key={`${prefix}/`} path={prefix || "/"} element={<Home />} />,
  <Route key={`${prefix}/materials`} path={`${prefix}/materials`} element={<Materials />} />,
  <Route key={`${prefix}/materials/:id`} path={`${prefix}/materials/:id`} element={<MaterialDetail />} />,
  <Route key={`${prefix}/applications`} path={`${prefix}/applications`} element={<Applications />} />,
  <Route key={`${prefix}/applications/:id`} path={`${prefix}/applications/:id`} element={<ApplicationDetail />} />,
  <Route key={`${prefix}/about`} path={`${prefix}/about`} element={<About />} />,
]);

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="system" storageKey="bionexus-theme">
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <I18nProvider>
            <Routes>
              {publicRoutes}
              <Route path="/auth" element={<Auth />} />
              <Route path="/.lovable/oauth/consent" element={<OAuthConsent />} />
              <Route path="/admin" element={
                <ProtectedRoute requireAdmin>
                  <AdminReview />
                </ProtectedRoute>
              } />
              <Route path="/admin/review" element={
                <ProtectedRoute requireAdmin>
                  <AdminPendingReview />
                </ProtectedRoute>
              } />
              <Route path="/admin/content" element={
                <ProtectedRoute requireAdmin>
                  <AdminContent />
                </ProtectedRoute>
              } />
              <Route path="/admin/materials/new" element={
                <ProtectedRoute requireAdmin>
                  <AdminMaterialEditor />
                </ProtectedRoute>
              } />
              <Route path="*" element={<NotFound />} />
            </Routes>
            </I18nProvider>
          </BrowserRouter>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
